/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_DataInputs */

const fr_nav_data = /** @type {(inputs: Nav_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Données`)
};

const en_nav_data = /** @type {(inputs: Nav_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data`)
};

/**
* | output |
* | --- |
* | "Data" |
*
* @param {Nav_DataInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_data = /** @type {((inputs?: Nav_DataInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_DataInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_nav_data(inputs)
	return en_nav_data(inputs)
});